import { render, staticRenderFns } from "./MaterialWorkshops.vue?vue&type=template&id=6db870ea"
import script from "./MaterialWorkshops.vue?vue&type=script&lang=js"
export * from "./MaterialWorkshops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports